import { startOfDay } from "date-fns";
import { InvoiceSubType } from "../enums/invoiceSubType"

export const isProductionInvoice = (invoiceSubType: InvoiceSubType): boolean => { 
  const productionTypes: InvoiceSubType[] = ["ProductionInvoice", "CorrectedProductionInvoice"];

  return productionTypes.some(x => x === invoiceSubType);
}

export const isInfoviceBeforeDueDate = (dueDate: Date): boolean => { 
  let actualDate = startOfDay(new Date());
  let parsedDueDate = startOfDay(new Date(dueDate));

  return actualDate <= parsedDueDate;
}